import { baseDocSerializer } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

const supportTicketStatuses = ["new", "open", "resolved", "closed"] as const;

export const activeSupportTicketStatuses = ["new", "open"] as const;

export const ticketReaderSerializer = Serializers.object({
  user: Serializers.string,
  isRead: Serializers.boolean,
});

export type TicketReader = SerializerValue<typeof ticketReaderSerializer>;

export const supportTicketDocSerializer = Serializers.object({
  ...baseDocSerializer("support-ticket").fields,
  ticketUuid: uuidSerializer,
  status: Serializers.stringOneOf(...supportTicketStatuses),
  ticketNumber: Serializers.string,
  createdAt: Serializers.datetime,
  assigneeEmails: Serializers.string.array(),
  readers: ticketReaderSerializer.array(),
});

export type SupportTicketDoc = SerializerValue<typeof supportTicketDocSerializer>;

export const isActiveSupportTicket = (ticket: SupportTicketDoc): boolean =>
  !ticket.isArchived && activeSupportTicketStatuses.some((status) => status === ticket.status);
